module.exports = __webpack_public_path__ + "static/img/empty-policies.ba808bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty-policies.png
// module id = nH8m
// module chunks = 1